import { Image, Link, Box, Flex } from "@chakra-ui/react";
import React, { useState, useEffect } from "react";

const FooterSlide = ({ item }) => (
  <Link
    href={item?.adlink || "#"}
    isExternal
    display="block"
    _hover={{ opacity: 0.9 }}
  >
    <Image
      src={item?.adurl}
      objectFit="cover"
      aspectRatio="3/1"
      w="100%"
      alt="advertisement"
    />
  </Link>
);

const Footer = ({ footerData }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const isArray = Array.isArray(footerData);
  const items = isArray ? footerData : null;

  useEffect(() => {
    if (!isArray || items.length <= 1) return;

    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % items.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [isArray, items]);

  if (!footerData) return null;

  // Single object — original behaviour
  if (!isArray) {
    return <FooterSlide item={footerData} />;
  }

  // Array — slider
  if (items.length === 0) return null;
  if (items.length === 1) return <FooterSlide item={items[0]} />;

  return (
    <Box position="relative" overflow="hidden" borderRadius="xl">
      {items.map((item, index) => (
        <Box
          key={index}
          position={index === 0 ? "relative" : "absolute"}
          top={0}
          left={0}
          w="100%"
          opacity={index === currentIndex ? 1 : 0}
          transition="opacity 0.6s ease-in-out"
          pointerEvents={index === currentIndex ? "auto" : "none"}
        >
          <FooterSlide item={item} />
        </Box>
      ))}

      {/* Dot indicators */}
      <Flex
        position="absolute"
        bottom={2}
        w="100%"
        justifyContent="center"
        gap={1.5}
        zIndex={1}
      >
        {items.map((_, index) => (
          <Box
            key={index}
            as="button"
            onClick={() => setCurrentIndex(index)}
            w={index === currentIndex ? "20px" : "8px"}
            h="8px"
            borderRadius="full"
            bg={index === currentIndex ? "white" : "whiteAlpha.600"}
            transition="all 0.3s"
            cursor="pointer"
            border="none"
          />
        ))}
      </Flex>
    </Box>
  );
};

export default Footer;
